module.exports = __webpack_public_path__ + "static/media/my-info-menu-active-icon.3accf38d.svg";